<template>
  <div class="clock-in-out">
    <div class="viewEdit">
      <div class="card-filter-section">
        <div class="d-flex align-items-center flex-wrap">
         <div class="d-flex align-items-center">
            <div>
              <p class="task-timesheet">Quarterly Resource Report</p>
            </div>
            <div v-if="userInfo && userInfo.role && userInfo.role == 'SA'" class="w-lg-100">
              <custom-dropdown
                v-model="manage_by"
                :options="filterUserOptions"
                label="Manage By"
                multiple
                option-label="full_name" 
                option-value="id"
              />
            </div>
         </div>
          <div class="calendar mt-0 justify-content-center align-items-center calendarBg ml-auto">
            <div id="date-select" class="date-select mr-0">
              <div class="date-dropdown">
                <VueDatePicker v-model="date" type="quarter" no-header />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="resourceLoader">
        <table-loader :fields="quarter" />
      </div>
      <div v-else-if="!resourceLoader && quarterItems && Object.keys(quarterItems.reports).length > 0" class="project-health-report-list">
        <div class="row w-100 p-1">
          <div
            v-for="(userReports, userName) in quarterItems.reports"
            :key="userName"
            style="margin-bottom: 2rem;"
          >            
            <table class="report-table ml-1" style="width: 100%;">
              <thead>
                <tr>
                  <th colspan="10" class="header-first-row p-1">
                    {{ reportQuarterFormat(userReports[0].month, userReports[0].year) }} - {{ userName }}
                  </th>
                </tr>
                <tr>
                  <th class="p-75">Month</th>
                  <th>Total Team Member</th>
                  <th>Billable Team Members</th>
                  <th>Billable Member Percentage</th>
                  <th>Projects Added</th>
                  <th>Projects Closed</th>
                  <th>Dedicated Devs Added</th>
                  <th>Dedicated Devs Closed</th>
                  <th>Notes</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="data-row"
                  v-for="(report, index) in userReports"
                  :key="report.id || index"
                >
                  <td class="p-75">
                    {{ report && report.month ? reportMonthFormat(`${report.month}-${report.year}`) : 'N/A' }}
                  </td>
                  <td>{{ report.total_team_members}}</td>
                  <td>{{ report.billable_team_members }}</td>
                  <td>{{ report.percentage}}%</td>
                  <td>{{ report.projects_added }}</td>
                  <td>{{ report.projects_closed}}</td>
                  <td>{{ report.dedicated_devs_added }}</td>
                  <td>{{ report.dedicated_devs_closed}}</td>
                  <td
                    v-b-tooltip.hover.left
                    :title="report.notes && report.notes.trim().length > 15 ? report.notes : null"
                  >
                    {{ report.notes}}
                  </td>
                  <td>
                    <feather-icon
                      icon="EditIcon"
                      class="edit-icon mr-1"
                      size="18"
                      @click="openEditModal(report)"
                    />
                  <div
                    class="btnYes d-inline-block"
                    @click="reDirectTab(report)"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      class="edit-icon mr-1"
                      size="18"
                    />
                  </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="project-health-report-list w-100">
        <img src="@/assets/images/nodatafound/nodata.svg" alt="no-data" class="no-data-img" />
      </div>
      <QuarterlyReportModal :editFields="editFields" @submit="submitFieldUpdate" @hide="resetModal" />
    </div>
  </div>
</template>

<script>
import { VBToggle } from "bootstrap-vue";
import customDropdown from "@/components/dropdown/customDropdown.vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import TableButton from "../../@core/components/buttons/TableButton.vue";
import QuarterlyReportModal from './QuarterlyReportModal.vue'
import QuarterlyResourceMixin from '../../mixin/report/quarterlyReport/index'


const date = new Date();
export default {
  name: "ViewEditHeader",
  components: {
    TableButton,
    customDropdown,
    VueDatePicker,
    QuarterlyReportModal,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  mixins: [QuarterlyResourceMixin],
};
</script>

<style lang="scss">
@import "../../assets/scss/component-css/vieweditheader.scss";
@import "../../assets/scss/component-css/viewedit.scss";
@import "../../assets/scss/component-css/list.css";
@import "../../assets/scss/component-css/QuarterlyResourceReport.scss";
</style>